<template>
  <!-- Routes that mount a Fondation view (AuditJournal, Privacy*) render their own
       BaseBreadcrumb, so suppress the Parcours header there to avoid a duplicate
       (and stale) breadcrumb. Those routes also declare no context toolbar. -->
  <PageHeader v-if="!route.meta.hidePageHeader" />
  <RouterView />
</template>

<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router';
import { useMenuSectionGuard } from '@/composables/use-menu-section-guard';

const route = useRoute();

// Hosted here rather than in `main.ts`: `useCustomizer()` reads the injected config the first time
// it is called, and calling it outside a component context would leave the app without its
// `DefaultLayout`. This wrapper mounts inside the layout, on every routed page.
useMenuSectionGuard();
</script>
